import { Table, Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { stringDate } from '../../../../util';
import { getAllWeeksByYear } from '../../../../appRedux/actions';

export const FortnightlyWeeksModal = ({ catalogId }) => {
  const dispatch = useDispatch();
  const { fortnightlysWeeks } = useSelector((state) => state.fortnightlys);

  useEffect(() => {
    if (catalogId) {
      dispatch(getAllWeeksByYear(catalogId));
    }
  }, [dispatch, catalogId]);

  const columns = [
    {
      title: 'Semana',
      dataIndex: 'weekNumber',
      key: 'weekNumber',
    },
    {
      title: 'Catorcena',
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: 'Inicio',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (date) => stringDate(date),
    },
    {
      title: 'Fin',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (date) => stringDate(date),
    },
    // OPCIONAL: si traes la relación catalog en el query y quieres mostrar el año
    // {
    //   title: 'Año',
    //   key: 'year',
    //   render: (_, row) => row?.catalog?.year || '-',
    // },
  ];
  return <Table columns={columns} dataSource={fortnightlysWeeks} rowKey="id" />;
};
